<template>
  <transition name="fade">
    <simple-modal v-show="LoadingService.isActive()" class="modal">
      <figure class="image is-64x64">
        <img class="is-block" src="../assets/images/logo.png" alt="loading">
      </figure>
      <p class="title is-size-5 has-text-centered has-text-white mt-6" style="min-height: 2em">
        <span v-if="message">{{ $t(message) }}</span>
      </p>
    </simple-modal>
  </transition>
</template>

<script setup>
  import { computed } from 'vue';
  import LoadingService from '@/dossier/services/LoadingService';
  import SimpleModal from './modal/SimpleModal.vue';

  const message = computed(() => LoadingService.getMessage());
</script>

<style lang="scss" scoped>
  .modal {
    flex-direction: column;
    z-index: $loader-layer;
  }

  figure.image {
    margin: 0 auto;
  }

  img {
    max-height: 100%;
  }

  .fade-enter-active {
    transition: opacity .25s;
  }

  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
